import React from 'react';
import Hero from '../components/Hero';
import ProblemSolution from '../components/ProblemSolution';
import Solutions from '../components/Solutions';
import BenefitsSection from '../components/BenefitsSection';
import ImplementationProcess from '../components/ImplementationProcess';
import FAQ from '../components/FAQ';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <ProblemSolution />
      <Solutions />
      <BenefitsSection />
      <ImplementationProcess />
      <FAQ />
    </main>
  );
};

export default HomePage;
